<template>
    <div class="bee-data-table" :class="{'hide-header': hideHeader}" style="width: 100%">
        <bee-data-iterator
            :max-height="maxHeight"
            v-if="isFunds"
            ref="table"
            :hide-default-footer="hideFooter"
            :headers="localHeaders"
            :items="localItems"
            :items-per-page="hideFooter ? 10000000000000000 : 5"
            class="elevation-1 pb-0"
            :zebra="zebra"
            :item-class="itemClass"
            @contextmenu="(e, i) => $emit('contextmenu', e, i)"
            :editable-row-index="editableRowIndex"
            :addable="addable"
            :highlighted-color="highlightedColor"
            :highlighted-expression="highlightedExpression">
            <template v-for="header in localHeaders" v-slot:[`item.${localHeaders.indexOf(header)}`]="{ item }">
                <slot :name="`item.${localHeaders.indexOf(header)}`" :item="item"></slot>
            </template>
            <template v-for="header in localHeaders" v-slot:[`footer.${localHeaders.indexOf(header)}`]>
                <slot :name="`footer.${localHeaders.indexOf(header)}`"></slot>
            </template>
        </bee-data-iterator>
        <v-data-table
            v-else
            dense 
            ref="table"
            :hide-default-footer="hideFooter"
            :headers="localHeaders"
            :items="loadingData ? [] : localItems"
            :items-per-page="hideFooter ? 10000000000000000 : 5"
            :loading="loadingData"
            :loading-text="this.$t('loading')"
            :height="maxHeight"
            :fixed-header="fixedHeader"
            class="elevation-1 pb-0"
            :class="{'zebra': zebra, 'fixed-header': fixedHeader && !maxHeight, 'clickable': clickable}"
            :item-class="item => highlightedExpression ? highlightedExpression(item) : ''"
            @contextmenu:row="(e, i) => $emit('contextmenu', e, i)"
            @dblclick:row="(e, i) => $emit('dblclick:row', e, i)"
            :addable="false">
            <template slot="body.prepend" v-if="fixedHeader && !maxHeight">
                <tr>
                    <th v-for="header in localHeaders" :key="header.value" 
                    role="columnheader" scope="col" 
                    :aria-label="`${header.text} : Not sorted. Activate to sort ascending.`" 
                    aria-sort="none" class="text-center sortable" 
                    :style="{'width': header.width,'min-width': header.width}"><span>{{header.text}}</span><i aria-hidden="true" 
                    class="v-icon notranslate v-data-table-header__icon mdi mdi-arrow-up theme--light" 
                    style="font-size: 18px;"></i></th>
                </tr>
            </template>
            <template v-for="header in localHeaders" v-slot:[`item.${header.value}`]="{ item }" >
                <slot :name="`item.${header.value}`" :item="item"></slot>
            </template>
            <template v-for="header in localHeaders" v-slot:[`footer.${localHeaders.indexOf(header)}`] >
                <slot :name="`footer.${localHeaders.indexOf(header)}`"></slot>
            </template>
            <template v-slot:no-data>
                {{$t('no-data')}}
            </template>
        </v-data-table>
    </div>
</template>

<script>
import EventBus from '../../../../event-bus'
export default {
    props: ['items', 'headers', 'zebra', 'hideHeader', 'hideFooter', 'with-color', 'editableRowIndex', 'addable','isFunds', 'itemClass','loadingData','highlighted-color','highlighted-expression', 'max-height', 'fixedHeader', 'clickable'],
    data: () => ({
        table: undefined,
        currencyType: null,
        itemFocused: {
            index: null,
            value: null,
            header: {
                value: null
            },
            loadingData:false,
        }
    }),
    computed: {
        localHeaders:{
            get: function() { 
                return this.headers
            },
            set: function(value){
                this.headers = value
            }
        },
        localItems:{
            get: function() { 
                return this.items
            },
            set: function(value){
                this.items = value
            }
        },
    },
    methods: {
        openLoading()
        {
            if(this.isFunds)
                this.$refs.table.openLoading();
            else
                this.loadingData = true
        },
        closeLoading(){
            if(this.isFunds)
                this.$refs.table.closeLoading();  
            else
                this.loadingData = false
        }
    },
    watch:{
		localItems(){
            EventBus.$emit('assign-dynamic-width')
        },
        localHeaders(){
            this.$nextTick(()=>{
                EventBus.$emit('assign-dynamic-width')
            })
        }
    },

    i18n: {
        messages: {
            ar: { 
                'loading': 'جاري التحميل...',
                'no-data': 'لا تتوفر بيانات',
            },
            en: { 
                'loading': 'Loading...',
                'no-data': 'No data',
            },
            es: { 
                'loading': 'Cargando...',
                'no-data': 'Sin datos',
            },
        }
    }
}
</script>

<style>
.zebra tbody tr:nth-of-type(even) {
   background-color: rgba(0, 0, 0, .05);
}

.hide-header .header,
.hide-header .header .tr,
.hide-header .header .tr .th{
    height: 0px !important;
    opacity: 0;
    padding: 0px !important;
    line-height: 0;
}

.form-control {
    display: block;
    width: 100%;
    padding: .375rem .75rem;
    font-size: 1rem;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: .25rem;
    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}

.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
    box-shadow: unset !important;
    padding: 0 !important;
}

.theme--light.v-text-field--solo > .v-input__control > .v-input__slot {
    background: transparent !important;
}

.v-application td > .primary--text {
    border: 1px solid #222;
}

.bee-data-table .v-text-field__details {
    opacity: 0 !important;
    height: 0 !important;
}

.v-input__slot {
    margin-bottom: 0px !important;
}
.v-data-table > .v-data-table__wrapper > table > tbody > tr > th, .v-data-table > .v-data-table__wrapper > table > thead > tr > th, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > th {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    font-size: 0.92rem;
    height: 48px;
    font-weight: 400;
}
.v-data-table--dense > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table--dense > .v-data-table__wrapper > table > thead > tr > td, .v-data-table--dense > .v-data-table__wrapper > table > tfoot > tr > td {
    height: 40px;
}
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table > .v-data-table__wrapper > table > thead > tr > td, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
    font-size: 0.92rem;
    height: 40px;
}
.bee-data-table td:not(:last-child) {
    border-left: 1px solid #dddddd;
}
.fixed-header thead.v-data-table-header {
    position: fixed;
    left: 12px;
    right: 12px;
    top: auto;
    background-color: white;
    z-index: 1;
}
.fixed-header thead > tr
{
    width: 100%;
    display: inline-table;
}
.clickable tbody > tr{
    cursor: pointer;
}
</style>